import { render, staticRenderFns } from "./reverify.vue?vue&type=template&id=112efa5c"
import script from "./reverify.vue?vue&type=script&lang=js"
export * from "./reverify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports